module.exports = __webpack_public_path__ + "static/media/room-request.07483b40.jpg";